(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_INSTRUMENT_COORDINATOR', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'];
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
